import {
  createEntityAdapter,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import type { RootState } from "../../../../store/store";
import {
  type Assignee,
  fetchAssigneesByEstateThunk,
} from "./assigneeListOperations";

const assigneeListAdapter = createEntityAdapter<Assignee>();

// @ts-expect-error - Redux Toolkit 1.9.7 type issue
const assigneeListSlice = createSlice({
  name: "assigneeList",
  initialState: assigneeListAdapter.getInitialState(),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAssigneesByEstateThunk.fulfilled, (state, action) => {
      assigneeListAdapter.setAll(state, action.payload);
    });
  },
});

const selectors = assigneeListAdapter.getSelectors(
  (state: RootState) => (state.tickets.ticketDetail as any).assignees,
);

const selectIds = (_state: RootState, itemIds: number[]) => itemIds;

const selectByIds = createSelector(
  [selectors.selectAll, selectIds],
  (allAssignees, itemIds: number[] = []) => {
    const assignees = allAssignees.filter((assignee) =>
      itemIds.includes(assignee.id),
    );
    return assignees;
  },
);

export const assigneeListSelectors = { ...selectors, selectByIds };

export const reducer = assigneeListSlice.reducer;
